import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { ContentModel } from '@uno/common-cms';
import { Services } from '@uno/common-shared';
import client from './client';
var apiBasePath = '/semantic-score';
export var getKeywords = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lang) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("".concat(apiBasePath, "/getKeywords/").concat(lang));

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getKeywords(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var createKeyword = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(keyword, lang) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.post("".concat(apiBasePath, "/createKeyword"), {
              keyword: keyword,
              lang: lang
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createKeyword(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getScore = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var entityId, lang, keyword, text;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            entityId = _ref3.entityId, lang = _ref3.lang, keyword = _ref3.keyword, text = _ref3.text;
            _context3.next = 3;
            return client.post("".concat(apiBasePath, "/getScore"), {
              entityId: entityId,
              lang: lang,
              keyword: keyword,
              text: text,
              service: Services.CONTENT,
              model: ContentModel.Content
            });

          case 3:
            return _context3.abrupt("return", _context3.sent);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getScore(_x4) {
    return _ref4.apply(this, arguments);
  };
}();